import { ActionPersistData } from "@cervval.js/common-action/src/action.model";
import { Injectable } from "@cervval.js/common/src/dependencies/injectable";
import { ErrorWithCode } from "@cervval.js/common/src/errors/errors";
import { PermissionErrorCodes } from "../permissions.errors";

/**
 * Default PermissionContext type
 * Should be extended in app
 */
export type DefaultPermissionContext = Record<string, string | number | null>;

export type BuiltContext<PermissionContext> = { typeName: string, id: number, permissionContext?: PermissionContext };


/**
 * TODO : JsDoc
 */
export const PERMISSION_CONTEXT_SERVICE = "PermissionContextService";
export abstract class PermissionContextService<PermissionContext, ActionContext = void> {

    public abstract buildContext(tableName: string, object: unknown, action?: ActionPersistData<ActionContext>): Promise<BuiltContext<PermissionContext>>;

}

/**
 * Default Permission Context
 * This service should be replaced in app if permission depend on specific context (ex: permission per project)
 * PermissionContext is context of permissionService
 * ContextAction is context of an action in actionPersistData, it can be different of PermissionContext, and can be use in order to build permissionContext in buildContext function.
 */
@Injectable(PERMISSION_CONTEXT_SERVICE)
export class DefaultPermissionContextService<PermissionContext, ActionContext = void> implements PermissionContextService<PermissionContext, ActionContext> {

    /**
     * Default service returns empty context, override the service in your app to build the proper context depending on the element type
     */
    public buildContext(tableName: string, object: Record<string, unknown>, action?: ActionPersistData<ActionContext>): Promise<BuiltContext<PermissionContext>> {

        if ("id" in object && typeof object["id"] === "number") {
            const builtContext: BuiltContext<PermissionContext> = {
                typeName: tableName,
                id: object["id"]
            };
            return Promise.resolve(builtContext);
        } else {
            const error: ErrorWithCode = {
                code: PermissionErrorCodes.FAILED_TO_BUILD_CONTEXT,
                errorMessage: "ID is not present in object of type " + tableName
            };
            return Promise.reject(error);
        }
    }
}